












































import Vue from 'vue'

import HeaderGame from '@/components/widgets/bar/HeaderGame.vue'
import Maps from '@/components/Maps.vue'

export type DataType = {
  randomLatLng: google.maps.LatLng | null,
  panorama: google.maps.StreetViewPanorama | null,
  score: number,
  round: number,
  overlay: boolean,
}

export default Vue.extend({
  name: 'StreetView',

  components: {
    HeaderGame,
    Maps,
  },

  data(): DataType {
    return {
      randomLatLng: null,
      panorama: null,
      score: 0,
      round: 1,
      overlay: false,
    }
  },

  methods: {
    loadStreetView(): void {
      let service = new google.maps.StreetViewService()
      service.getPanorama({
        location: this.getRandomLatLng(),
        preference: google.maps.StreetViewPreference.NEAREST,
        radius: 100000,
        source: google.maps.StreetViewSource.OUTDOOR,
      }, this.checkStreetView)
    },

    getRandomLatLng(): google.maps.LatLng  {
      let lat = (Math.random() * 170) - 85
      let lng = (Math.random() * 360) - 180
      return new google.maps.LatLng(lat, lng)
    },

    checkStreetView(data: google.maps.StreetViewPanoramaData | null, status: google.maps.StreetViewStatus): void {
      if (status === google.maps.StreetViewStatus.OK) {
        this.panorama = new google.maps.StreetViewPanorama(document.getElementById('street-view')! as HTMLElement)
        this.panorama!.setOptions({
          zoomControl: false,
          addressControl: false,
          fullscreenControl: false,
          motionTracking: false,
          motionTrackingControl: false,
          showRoadLabels: false,
        })
        this.panorama!.setPano(data!.location!.pano!)
        this.panorama!.setPov({
          heading: 270,
          pitch: 0,
        })

        this.randomLatLng = data!.location!.latLng! as google.maps.LatLng
      } else {
        this.loadStreetView()
      }
    },

    updateScore(distance: number): void {
      this.score += distance
      this.overlay = true
    },

    goToNextRound(): void {
      this.randomLatLng = null
      this.overlay = false
      this.round += 1

      this.loadStreetView()
    },

    playAgain(): void {
      this.randomLatLng = null
      this.score = 0
      this.round = 1
      this.overlay = false

      this.loadStreetView()
    },

    resetLocation(): void {
      this.panorama!.setPosition(this.randomLatLng!)
    },

    zoomIn(): void {
      let currentLevel = this.panorama!.getZoom()
      currentLevel++
      this.panorama!.setZoom(currentLevel)
    },

    zoomOut(): void {
      let currentLevel = this.panorama!.getZoom()
      currentLevel--
      this.panorama!.setZoom(currentLevel)
    }
  },

  mounted(): void {
    this.loadStreetView()
  }
})
